import { render } from "./Room.vue?vue&type=template&id=4a7ecdbb"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"

import "./Room.vue?vue&type=style&index=0&id=4a7ecdbb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__